import { DocumentDisplayConfig } from '../DocumentDisplayConfig/DocumentDisplayConfigContext';
import { Summary } from './types';

export const filterSummaryByConfig = (summary: Summary, config: DocumentDisplayConfig): Summary => {
  const filteredContent = summary.content
    .map((section) => section.filter((item) => !item.requiresConfig || config[item.requiresConfig]))
    .filter((section) => section.length > 0);

  const filteredFooter =
    summary.footer?.requiresConfig && !config[summary.footer.requiresConfig] ? undefined : summary.footer;

  return {
    ...summary,
    content: filteredContent,
    footer: filteredFooter,
  };
};
